import { QuestionStatus } from '@exam-management/graphql';

export const HIDDEN_STATUSES = [
  QuestionStatus.InDevelopment,
  QuestionStatus.InReview,
  QuestionStatus.Published,
];
